import { TaskStatus } from "../../shared/models/TaskStatus";
import { DictionaryDto } from "../../tasksBoard/service/api/DictionaryDto";

export class TaskStatusesFromResponse {
    constructor(private taskStatusFromResponse: DictionaryDto) {}

    taskStatuses(): TaskStatus[] {
        return this.taskStatusFromResponse.itemList.map((item) => ({
            id: item.id,
            code: item.code,
            description: item.description,
            orderIndex: item.orderIndex,
            descriptionTranslationCode: item.descriptionTranslationCode,
            flexFilter1: item.flexFilter1,
        }));
    }
}
